import { useWixPatternsContainer } from '@wix/bex-core/react';

export const useCairoTranslations = () => {
  const { i18n, useTranslation } = useWixPatternsContainer();

  return useTranslation(i18n.options.defaultNS, { i18n });
};
